import React from 'react';
import { Grid, Typography } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import moment from 'moment';
import CustomLabel from './CustomLabel';

const API_FORMAT = 'YYYY-MM-DD';
const DISPLAY_FORMAT = 'DD-MMM-YYYY';

// Same look as the other filter inputs (.filter-autocomplete in index.scss).
const textFieldSx = {
  '& .MuiOutlinedInput-root': { borderRadius: '8px', backgroundColor: '#fff' },
  '& .MuiOutlinedInput-notchedOutline': { borderColor: '#ebe8fb !important', borderRadius: '8px' },
  '& .MuiOutlinedInput-input': { paddingBlock: '14.5px' },
};

const toMoment = (value) => (value ? moment(value, API_FORMAT) : null);
const toApi = (date) => (date && moment(date).isValid() ? moment(date).format(API_FORMAT) : '');

// "Filter by date range" section for the admin filter popups: From / To pickers
// matching investor-web's date range picker. Values stay YYYY-MM-DD strings.
const FilterDateRange = ({ from, to, onChange, title = 'Filter by date range' }) => {
  const fromDate = toMoment(from);
  const toDate = toMoment(to);
  const slotProps = { textField: { fullWidth: true, placeholder: DISPLAY_FORMAT, sx: textFieldSx } };

  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <Grid item xs={12}>
        <Typography sx={{ fontWeight: 700, fontSize: '1rem', marginTop: '0.5rem' }}>{title}</Typography>
      </Grid>
      <Grid item xs={12} sm={6}>
        <CustomLabel sx={{ textTransform: 'none' }}>From</CustomLabel>
        <DatePicker
          format={DISPLAY_FORMAT}
          value={fromDate}
          maxDate={toDate || undefined}
          onChange={(date) => onChange({ from: toApi(date), to })}
          slotProps={slotProps}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <CustomLabel sx={{ textTransform: 'none' }}>To</CustomLabel>
        <DatePicker
          format={DISPLAY_FORMAT}
          value={toDate}
          minDate={fromDate || undefined}
          onChange={(date) => onChange({ from, to: toApi(date) })}
          slotProps={slotProps}
        />
      </Grid>
    </LocalizationProvider>
  );
};

export default FilterDateRange;
